import { render, staticRenderFns } from "./refundIndex.vue?vue&type=template&id=284b81c9"
import script from "./refundIndex.vue?vue&type=script&lang=js"
export * from "./refundIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports